import React from "react";

// dashboard Imports
import Maindashboard from "./dashboard/others/main"
import Teammate from "./dashboard/others/teammates"
import Referrallink from "./dashboard/others/refferrallink"
import Productsdetails from "./dashboard/others/productsdetails"
import Payoutdetails from "./dashboard/others/payoutdetails"
import Profile from "./dashboard/others/profile"
import Sendmessage from "./dashboard/others/sendmessage"
import Frequentlyask from "./dashboard/others/frequentlyask";
import ContactSupport from "./dashboard/others/contactsupport";
import ViewAccount from "./dashboard/others/viewaccounts"
import ClientManagement from "./dashboard/others/clients";




// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
} from "react-icons/md";

import { FaUserPlus } from "react-icons/fa";
import { FaLink, FaCartShopping } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import { LuMessagesSquare } from "react-icons/lu";
import { FaQuestion } from "react-icons/fa6";
import { MdOutlineContactPhone } from "react-icons/md";
import { MdOutlineAccountBalance } from "react-icons/md";

const routes = [
  {
    name: "Dashboard",
    layout: "/dashboard",
    path: "main",
    icon: <MdHome className="h-6 w-6" />,
    component: <Maindashboard />,
  },
  {
    name: "Realtors",
    layout: "/dashboard",
    path: "team-mate",
    icon: <FaUserPlus className="h-6 w-6" />,
    component: <Teammate />,
    secondary: true,

  },
  {
    name: "Clients",
    layout: "/dashboard",
    path: "clients",
    icon: <FaUserPlus className="h-6 w-6" />,
    component: <ClientManagement />,
    secondary: true,

  },

  {
    name: "Payout Details",
    layout: "/dashboard",
    path: "payout-details",
    icon: <GiMoneyStack className="h-6 w-6" />,
    component: <Payoutdetails />,
  },
  {
    name: "Profile",
    layout: "/dashboard",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "View Accounts",
    layout: "/dashboard",
    path: "viewaccount",
    icon: <MdOutlineAccountBalance className="h-6 w-6" />,
    component: <ViewAccount />,
  },
  {
    name: "Contact",
    layout: "/dashboard",
    path: "contact",
    icon: <MdOutlineContactPhone className="h-6 w-6" />,
    component: <ContactSupport />,
  },
  {
    name: "FAQ",
    layout: "/dashboard",
    path: "Frequentlyaskquestion",
    icon: <FaQuestion className="h-6 w-6" />,
    component: <Frequentlyask />,
  },
];
export default routes;
